// Fechas para mostrar.
//
// Un campo de fecha sin hora del backend ("2026-10-10") pasado a `new Date(...)` se lee como medianoche UTC, y en
// Buenos Aires (UTC-3) se muestra un día antes ("9/10/2026"). `aFechaLocal` lo arma como fecha local; una fecha con
// hora ("2026-10-10T14:30:00-03:00") o un Date se usan tal cual, como antes.

const SOLO_FECHA = /^(\d{4})-(\d{2})-(\d{2})$/;

export const aFechaLocal = (valor) => {
  if (valor === null || valor === undefined || valor === "") return null;
  if (valor instanceof Date) return Number.isNaN(valor.getTime()) ? null : valor;
  const texto = String(valor).trim();
  const m = texto.match(SOLO_FECHA);
  const fecha = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(texto);
  return Number.isNaN(fecha.getTime()) ? null : fecha;
};

// Igual que `new Date(valor).toLocaleDateString(locale, opciones)`, sin correr un día las fechas sin hora.
// Devuelve `vacio` si no hay fecha válida.
export const formatearFecha = (valor, { locale = "es-AR", opciones, vacio = "" } = {}) => {
  const fecha = aFechaLocal(valor);
  return fecha ? fecha.toLocaleDateString(locale, opciones) : vacio;
};

// "YYYY-MM-DD" de hoy en la hora local. `new Date().toISOString().slice(0, 10)` da la fecha UTC: en Buenos Aires,
// después de las 21 ya es "mañana".
export const hoyISO = (ahora = new Date()) => {
  const mes = String(ahora.getMonth() + 1).padStart(2, "0");
  const dia = String(ahora.getDate()).padStart(2, "0");
  return `${ahora.getFullYear()}-${mes}-${dia}`;
};
